module.exports = {"510903001":"南津路街道","510903002":"凯旋路街道","510903003":"高升街街道","510903004":"镇江寺街道","510903005":"育才路街道","510903006":"介福路街道","510903007":"嘉禾街道","510903008":"广德街道","510903009":"富源路街道","510903010":"龙坪街道","510903011":"灵泉街道","510903012":"慈音街道","510903013":"九莲街道","510903014":"南强街道","510903015":"金家沟街道","510903100":"龙凤镇","510903101":"仁里镇","510903102":"复桥镇","510903103":"永兴镇","510903104":"河沙镇","510903105":"新桥镇","510903106":"桂花镇","510903200":"西宁乡","510903201":"老池乡","510903202":"保升乡","510903203":"唐家乡","510903204":"北固乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510903.json
// module id = 2317
// module chunks = 0